

<ng-container *ngIf="field.ui.type=='TEXT_FIELD'">

    <app-text-field [formGroup]="myForm"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" [submitted]="submitted" [yourTurn]="yourTurn"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        [isContainer]="false"
        [hidden]="field.hidden"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        >
    </app-text-field>    

</ng-container>

<ng-container *ngIf="field.ui.type=='TEXT_VIEW'">

    <app-text-view
        [formGroup]="myForm!"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)"
        [field]="field.ui"
        [value]="myForm?.get(field.ui.id)?.value"
        [fieldId]="field.ui.id"
        [hidden]="field.hidden"
        [submitted]="submitted" [yourTurn]="yourTurn"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        ></app-text-view>

</ng-container>

<ng-container *ngIf="field.ui.type=='CHECKBOX'">

    <app-checkbox [formGroup]="myForm"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" [submitted]="submitted" [yourTurn]="yourTurn"
        [isContainer]="false"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        >
    </app-checkbox>



</ng-container>


<ng-container *ngIf="field.ui.type=='COMBO_BOX'">

    <app-combo-box [formGroup]="myForm"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" [submitted]="submitted" [yourTurn]="yourTurn"
        [isContainer]="false"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        ></app-combo-box>


</ng-container>

<ng-container *ngIf="field.ui.type=='MULTI_COMBO_BOX'">

    <app-multi-select [formGroup]="myForm"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" [submitted]="submitted" [yourTurn]="yourTurn"
        [isContainer]="false"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        ></app-multi-select>

</ng-container>

<ng-container *ngIf="field.ui.type=='MULTI_PREDEFINED_COMBO_BOX'">

    <app-predfiend-multi-select [formGroup]="myForm"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" [submitted]="submitted" [yourTurn]="yourTurn"
        [isContainer]="false"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        ></app-predfiend-multi-select>

</ng-container>


<ng-container *ngIf="field.ui.type=='PREDEFINED_COMBO_BOX'">

    <app-predefined-combo-box [formGroup]="myForm" id="compo_{{field.ui.id}}"
        [errors]="getFormControlErrors(field.ui.id)"
        [isInvalid]="getFormControlValidation(field.ui.id)" [field]="field.ui"
        [fieldId]="field.ui.id" 
        [submitted]="submitted" [yourTurn]="yourTurn"
        [isContainer]="false"
        [containerFieldId]="undefined" [fieldIndex]="undefined"
        (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"
        ></app-predefined-combo-box>

</ng-container>


<ng-container *ngIf="field.ui.type=='FILE'">

    <app-file 
    [formGroup]="myForm"
    [errors]="getFormControlErrors(field.ui.id)"
    [files]="getFiles(field.ui.id)"
    [isInvalid]="getFiles(field.ui.id).length==0 && field.ui.required"
    [field]="field.ui"
    [fieldId]="field.ui.id"
    [submitted]="submitted"
    [yourTurn]="yourTurn"
    [containerFieldId]="undefined"
    [fieldIndex]="undefined" 
    [isContainer]="false"
    (refreshFormEvent)="refreshForm(field.id,field.shouldRefresh,containerFieldId,fieldIndex,isContainer)"    
    >
</app-file>